var _excluded = ["logo", "label", "title", "description", "price", "link", "onClick"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from "react";
import OnColorContext from "../../../contexts/OnColorContext";
import FlexContainerOrg from "../../organisms/FlexContainerOrg";
import FlexItemOrg from "../../organisms/FlexItemOrg";
import PushOrg from "../../organisms/PushOrg";
import Link from "../../quarks/Link";
import { Box, Title, Logo, LabelWrapper, Content, Description } from "./AdvancedProductTileMol.styled";
function AdvancedProductTileMol(_ref) {
  var logo = _ref.logo,
    label = _ref.label,
    title = _ref.title,
    description = _ref.description,
    price = _ref.price,
    link = _ref.link,
    onClick = _ref.onClick,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var onColor = useContext(OnColorContext);
  return /*#__PURE__*/React.createElement(Box, _extends({
    $onColor: onColor,
    onClick: onClick
  }, restProps), /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(FlexContainerOrg, {
    justifyContent: "space-between",
    wrap: "wrap"
  }, /*#__PURE__*/React.createElement(Logo, null, logo), /*#__PURE__*/React.createElement(FlexItemOrg, {
    alignSelf: "flex-end"
  }, /*#__PURE__*/React.createElement(LabelWrapper, null, label))), /*#__PURE__*/React.createElement(Title, null, /*#__PURE__*/React.createElement(Link, link, title)), /*#__PURE__*/React.createElement(Description, null, description)), /*#__PURE__*/React.createElement(PushOrg, {
    topSpace: 3
  }, price));
}
export default AdvancedProductTileMol;